/* eslint-disable camelcase */
import React from 'react';
import { MM_DD_YYYY } from 'aegion_common_utilities/lib/format/datetime';

import './HistoryDetails.scss';

const hasFullNameConflicts = (editors) => {
	const ref = [...new Set(editors.map(u => u.fullName))];
	return ref.length !== editors.length;
}

const formatUser = (fullName, userid, blnHasNameConflicts) => {
	if (blnHasNameConflicts && fullName && userid) {
		return `${fullName} (${userid})`;
	}

	return fullName || userid;
}

const ReportHistoriesDetails = ({ reportHistories }) => {
	if (!reportHistories || !reportHistories.length) {
		return null;
	}

	return <div className="wrapper-lines-aggs-history-details-table">
		<h2>
			Report History<br/>
			<small>The below users have created reports for this line.</small>
		</h2>

		<hr/>

		<table>
			<thead>
				<tr>
					<th>
						Type
					</th>
					<th>
						Created By
					</th>
					<th>
						Edited by
					</th>
					<th>
						Last Edited
					</th>
				</tr>
			</thead>
			<tbody>
				{reportHistories.map(summary => { 
					const {
						owner_full_name,
						owner_userid,
						original_created_date,
						created_date,
						report_type_name
					} = summary.currentReport || {};
					const blnHasNameConflicts = hasFullNameConflicts(summary.editors || []);

					return (
						<tr>
							<td>
								{report_type_name}
							</td>
							<td>
								<div>{formatUser(owner_full_name, owner_userid, blnHasNameConflicts)}</div>
								<div>{MM_DD_YYYY(original_created_date)}</div>
							</td>
							<td>{
								(summary.editors || []).map(user => (
									<div>{formatUser(user.fullName, user.userid, blnHasNameConflicts)}</div>
								))
							}</td>
							<td>{MM_DD_YYYY(created_date)}</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	</div>
}

const AppStateHistoriesDetails = ({ appStateHistories }) => {
	if (!appStateHistories || !appStateHistories.length) {
		return null;
	}

	return <div className="wrapper-lines-aggs-history-details-table">
		<h2>
			User Data History<br/>
			<small>The below users have saved data for this line.</small>
		</h2>

		<hr/>

		<table>
			<thead>
				<tr>
					<th>
						Created By
					</th>
					<th>
						Edited by
					</th>
					<th>
						Last Edited
					</th>
				</tr>
			</thead>
			<tbody>
				{appStateHistories.map(summary => { 
					const {
						owner_full_name,
						owner_userid,
						original_created_date,
						created_date
					} = summary.currentState || {};
					const blnHasNameConflicts = hasFullNameConflicts(summary.editors || []);

					return (
						<tr>
							<td>
								<div>{formatUser(owner_full_name, owner_userid, blnHasNameConflicts)}</div>
								<div>{MM_DD_YYYY(original_created_date)}</div>
							</td>
							<td>{
								(summary.editors || []).map(user => (
									<div>{formatUser(user.fullName, user.userid, blnHasNameConflicts)}</div>
								))
							}</td>
							<td>{MM_DD_YYYY(created_date)}</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	</div>
}

const HistoryDetails = ({historyDetails}) => { 
	return (
		<div style={{padding: '10px'}}>
			<ReportHistoriesDetails reportHistories={historyDetails.reports} />
			<AppStateHistoriesDetails appStateHistories={historyDetails.appStates} />
		</div>
	)
}

export default HistoryDetails;